module.exports = __webpack_public_path__ + "img/logo_sistema.477ff33a.png";